/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
import {UpdateIdentityValidationModalApp} from "../Functionality/UpdateIdentityValidationModalApp";
import CustomModal from "../../../../../components/Modal/CustomModal";
import {CustomTextField} from "../../../../../components/CustomTextField";

const UpdateIdentityValidationModal = (props) => {
    const {onHide, title, required, description} = props

    const {
        resetValues,
        emptyFields,
        handleChange,
        t,
        handleCreate,
        data,
    } = UpdateIdentityValidationModalApp(props)


    return (
        <CustomModal
            {...props}
            title={t(title)}
            size='md'
            onConfirm={() => {
                handleCreate()
            }}
            onHide={() => {
                onHide();
                resetValues();
            }}
            classNameBody="pt-2"
        >
            <div className={"d-flex flex-column justify-content-center align-items-center"}>
                <p className={"ibl-ientry-p ibl-font-w-400"}>{t('are_you_sure_to_proceed')}</p>
                <p className={"ibl-ientry-p ibl-font-w-600 text-uppercase"}>{t(description)}</p>
            </div>
            <div className={"mt-3"}>
                <CustomTextField
                    length={200}
                    id='txt_uivm_reason'
                    name='reason'
                    value={data.reason}
                    trans='comment'
                    emptyFields={emptyFields}
                    required={required}
                    onChange={handleChange}
                    multiline={true}
                    row={4}
                />
            </div>
        </CustomModal>
    );
};

export default UpdateIdentityValidationModal
